import { render, staticRenderFns } from "./confirmLink.vue?vue&type=template&id=50f1d5e6"
import script from "./confirmLink.ts?vue&type=script&lang=js&external"
export * from "./confirmLink.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports